import { render, staticRenderFns } from "./EDialogDetailSaleComp.vue?vue&type=template&id=ccb2b39a&"
import script from "./EDialogDetailSaleComp.vue?vue&type=script&lang=js&"
export * from "./EDialogDetailSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports